import { render } from "./SelectedFacets.vue?vue&type=template&id=0eb23353"
import script from "./SelectedFacets.vue?vue&type=script&lang=js"
export * from "./SelectedFacets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__